import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// API helper
import { apiHelper } from '../../../helper/apiHelper';

// components
import dynamic from 'next/dynamic';
const ExploreList = dynamic(() => import('../../../components/ExploreList'))

export default function ExplorePage(props) {
    return (
        <ExploreList faq={props && props.faq} content={props && props.meta} currLocale={props.currLocale} />
    )
}
export const getStaticProps = async ({ locale }, ctx) => {
    var expName = "ethereum";
    var pageName = 'explore';

    var postData = {
        language: locale,
        pageName: pageName
    }
    const resMeta = await apiHelper(`metadata/getNftMetadata`, "POST", postData, null);
    const meta = resMeta.data.status ? resMeta.data.data : null;

    const resFAQ = await apiHelper(`metadata/getNftPagesFaqs/${expName}/${locale}`, "GET", null, null);
    const faq = resFAQ.data.status ? resFAQ.data.data : null;

    const canonical = process.env.hostBaseUrl + '/' + locale + '/nft/' + pageName;
    return {
        props: {
            meta,
            faq,
            ogImage: 'nft-blockchain-network-en-social.png',
            currLocale: locale,
            revalidate: 10,
            canonical,
            pageName: meta && meta.pageHeading ? meta.pageHeading : '',
            dynamicURL: '/nft/' + pageName,
            ...(await serverSideTranslations(locale, ['common']))
        },
        revalidate: 10, // In seconds
    }
}